import { Head, Link, useForm } from '@inertiajs/react'
import type { FormEvent } from 'react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Checkbox } from '@/components/ui/checkbox'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

interface Props {
  errors?: Record<string, string | string[]>
}

export default function New({ errors }: Props) {
  const form = useForm({
    thesession_url: '',
    tune: { name: '' },
    known: false,
  })

  const nameError = errors?.name
  const showNameError = Array.isArray(nameError) ? nameError.join(', ') : nameError

  function submit(e: FormEvent) {
    e.preventDefault()
    form.post('/tunes')
  }

  return (
    <>
      <Head title="Add tune" />

      <div className="mb-6 flex items-center justify-between">
        <h1 className="text-2xl font-semibold tracking-tight">Add tune</h1>
        <Button variant="ghost" asChild>
          <Link href="/tunes">Cancel</Link>
        </Button>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Capture a tune</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-5">
            <div className="space-y-2">
              <Label htmlFor="thesession_url">thesession.org URL</Label>
              <Input
                id="thesession_url"
                placeholder="https://thesession.org/tunes/63"
                value={form.data.thesession_url}
                onChange={(e) => form.setData('thesession_url', e.target.value)}
              />
              <p className="text-xs text-muted-foreground">
                Paste a link to auto-fill name, type, key and ABC.
              </p>
            </div>

            <div className="space-y-2">
              <Label htmlFor="name">Or just a name</Label>
              <Input
                id="name"
                placeholder="The Kesh"
                value={form.data.tune.name}
                onChange={(e) => form.setData('tune', { name: e.target.value })}
              />
              {showNameError && <p className="text-xs text-destructive">{showNameError}</p>}
            </div>

            <div className="flex items-center gap-2">
              <Checkbox
                id="known"
                checked={form.data.known}
                onCheckedChange={(v) => form.setData('known', v === true)}
              />
              <Label htmlFor="known">I already know this tune</Label>
            </div>

            <Button type="submit" disabled={form.processing}>
              Add tune
            </Button>
          </form>
        </CardContent>
      </Card>
    </>
  )
}
